import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useConfiguratorContext } from '../../Context/ConfiguratorContext.js';
import { useSteps } from '../../hooks/use-steps.js';
import { StepForm, ConnectedStepForm } from './StepForm.js';

const StepFormContainer = (props)=>{
    const { getLabel  } = useIntl();
    const { configuratorId  } = useConfiguratorContext();
    const { currentStep  } = useSteps();
    const { labelKeys  } = currentStep;
    const labels = React__default.useMemo(()=>({
            ariaLabel: getLabel(labelKeys.title)
        })
    , [
        getLabel,
        labelKeys.title
    ]);
    return /*#__PURE__*/ React__default.createElement(StepForm, swcHelpers.extends({}, props, {
        configuratorId: configuratorId,
        "aria-label": labels.ariaLabel
    }));
};
const ConnectedStepFormContainer = (props)=>{
    const { getLabel  } = useIntl();
    const { configuratorId  } = useConfiguratorContext();
    const { currentStep  } = useSteps();
    const { labelKeys  } = currentStep;
    const labels = React__default.useMemo(()=>({
            ariaLabel: getLabel(labelKeys.title)
        })
    , [
        getLabel,
        labelKeys.title
    ]);
    return /*#__PURE__*/ React__default.createElement(ConnectedStepForm, swcHelpers.extends({}, props, {
        configuratorId: configuratorId,
        "aria-label": labels.ariaLabel
    }));
};

export { ConnectedStepFormContainer, StepFormContainer };
//# sourceMappingURL=StepFormContainer.js.map
